function splitInt(str, delimiter = ',') {
    if (str === undefined) {
        return [];
    }
    if (Number.isInteger(str)){
        return [str];
    }
    let items = str.split(delimiter);
    let results = [];
    items.forEach(function (item) {
        results.push(parseInt(item.trim()));
    });
    return results;
}

function split(string, delimiter = ',') {
    if (string === undefined) {
        return [];
    }
    let items = string.split(delimiter);
    let results = [];
    items.forEach(function (item) {
        results.push(item.trim());
    });
    return results;
}

export function capitalize(string) {
    return string[0].toUpperCase() + string.slice(1);
}

export function toCamelCase(str) {
    // Lower cases the string
    return str.toLowerCase()
    // Replaces any - or _ characters with a space
        .replace( /[-_]+/g, ' ')
        // Removes any non alphanumeric characters
        .replace( /[^\w\s]/g, '')
        // Uppercases the first character in each group immediately following a space
        // (delimited by spaces)
        .replace( / (.)/g, function($1) { return $1.toUpperCase(); })
        // Removes spaces
        .replace( / /g, '' );
}


// WEBPACK FOOTER //
// ./resources/assets/js/src/parsers.js